import styled, { css, keyframes } from 'styled-components';

import type { Color } from '../../../../style/types/theme';

interface StyledBorderProps {
  $isDragging: boolean;
  $isHovered: boolean;
}

const dragIn = () =>
  keyframes({
    '0%': {
      strokeDashoffset: 100,
    },
    '100%': {
      strokeDashoffset: 0,
    },
  });

const getStroke = (isDragging: boolean, isHovered: boolean, color: Color) => {
  if (isDragging) {
    return color.border.accent.default();
  }

  return isHovered ? color.border.primary.hover() : color.border.primary.default();
};

export const StyledBorder = styled.svg<StyledBorderProps>(
  ({ theme: { color, transition, size }, $isDragging, $isHovered }) => ({
    fill: 'transparent',
    width: '100%',
    height: '100%',
    padding: size.units(0.125),
    stroke: getStroke($isDragging, $isHovered, color),
    transition: transition.standard('stroke', 'stroke-dashoffset'),
    strokeDashoffset: $isHovered ? 100 : 90,
    overflow: 'visible',
  }),
  ({ $isDragging }) => css`
    animation: ${dragIn} ${$isDragging ? 2 : 0}s infinite linear;
  `,
);
